import md5 from 'js-md5';
import axios from '@/../node_modules/axios/index';
const C_HOST = 'https://capiv2-t.xinyue.qq.com?cmd=jcejsonrouter'
axios.defaults.withCredentials = true;
const request = {
	post (url, params) {
		let timeStamp = Math.floor(new Date().getTime() / 1000)
		let acctType
		let openId
		let accessToken
		let appid
		if (window.milo) {
			acctType = window.milo.cookie.get('acctype') || 'qq'
			if (acctType === 'qq') {
				accessToken = window.milo.cookie.get('skey')
				let nth = window.milo.cookie.get('uin')
				let nth2 = nth.slice(1)
				let nth3 = nth2.slice(0, 1)
				if (parseInt(nth3) === 0) {
					openId = nth2.slice(1)
				} else {
					openId = nth2
				}
			} else {
				openId = window.milo.cookie.get('openid')
				accessToken = window.milo.cookie.get('access_token')
				appid = window.milo.cookie.get('appid')
			}
		}
		let plainText = url + openId + accessToken + appid + timeStamp + JSON.stringify(params)
		let sign = md5(plainText)
		let data = {
			body: {
				request: {
					cmd: url,
					acct_type: acctType,
					appid: appid,
					business: '',
					openid: openId,
					timestamp: timeStamp,
					access_token: accessToken,
					sign: sign,
					req: JSON.stringify(params)
				}
			}
		}
		/* eslint-disable */
    return axios({
      data: JSON.stringify(data),
      url: C_HOST,
      method: 'POST',
      withCredentials: true, // 允许携带cookie
      headers: {
        'Content-Type': 'text/plain',
        // 'Accept': 'application/json',
      },
    }).then(function (response) {
      if (response.data && response.data.ret === 0 && response.data.data && response.data.data.response && response.data.data.response.rsp) {
        return response.data.data.response.rsp
      } else {
        throw response
      }
    })
    /* eslint-enable */
	}
}
/* eslint-disable no-undef */
function delay (time) {
	return new Promise((resolve, reject) => {
		setTimeout(() => resolve(), time);
	})
}
/**
 * @description 提交ams流程
 * @param {string} argv ams 流程id
 * @returns {Promise}	返回promise对象
 */
const doAmsAction = (flowId = '', sData = {}) => {
	if (typeof (window.bindInfo) !== 'undefined' && typeof (window.bindInfo.sRoleId) !== 'undefined') {
		sData['sArea'] = bindInfo.sArea
		sData['sPlatId'] = bindInfo.sPlatId
		sData['sPartition'] = bindInfo.sPartition
		sData['sRoleId'] = bindInfo.sRoleId
	}
	sData['openidA'] = (typeof (window._Vue.$route) !== 'undefined' && typeof (window._Vue.$route.query) !== 'undefined' && typeof (window._Vue.$route.query.openidA) !== 'undefined') ? window._Vue.$route.query.openidA : ''
	sData['sTunnel'] = 1
	sData['sServiceType'] = window._Vue.$actConfig.gameCode
	const actId = _Vue.$actConfig && _Vue.$actConfig.actId ? _Vue.$actConfig.actId : '';
	return delay(500).then(() => {
		return new Promise((resolve, reject) => {
			window.rv = resolve;
			window.rj = reject;
			window['amsCfg_' + flowId] = {
				'iActivityId': actId,
				'iFlowId': flowId,
				'sData': sData,
				'gameId': window._Vue.$actConfig.gameCode,
				'fFlowSubmitEnd': function (res) {
					const { sPackageName, iPackageId } = res;
					window.rv({ ...res, sPackageName, iPackageId });
				},
				'fFlowSubmitFailed': function (res) {
					window.rj(res);
				}
			}
			amsSubmit(actId, flowId);
		});
	})
}
/**
 * @description 提交ame流程
 * @param {string} argv ame 流程id
 * @returns {Promise}	返回promise对象
 */
const doAmeAction = (flowId = '', sData = {}) => {
	console.log(sData)
	console.log(flowId)
	sData['openidA'] = (typeof (window._Vue.$route) !== 'undefined' && typeof (window._Vue.$route.query) !== 'undefined' && typeof (window._Vue.$route.query.openidA) !== 'undefined') ? window._Vue.$route.query.openidA : ''
	const actId = _Vue.$actConfig && _Vue.$actConfig.actId ? _Vue.$actConfig.actId : '';
	return delay(500).then(() => {
		return new Promise((resolve, reject) => {
			window['amsCfg_' + flowId] = {
				'iActivityId': actId,
				'iFlowId': flowId,
				'sData': sData,
				'gameId': window._Vue.$actConfig.gameCode,
				'fFlowSubmitEnd': function (res) {
					console.log(res)
					if (res.jData) {
						const { jData } = res
						if (res.iRet === 0) {
							resolve({ ...res, jData });
						} else {
							reject(jData)
						}
					} else {
						if (res.iRet === '0') {
							resolve({ res });
						} else {
							reject(res.sMsg)
						}
					}
				},
				'fFlowSubmitFailed': function (res) {
					reject(res);
				}
			}
			amsSubmit(actId, flowId);
		});
	})
}
/**
 * @description 提交ame流程
 * @param {string} argv ame 流程id
 * @returns {Promise}	返回promise对象
 */
const doRecordAction = (flowId = '', sData = {iPageSize: 10, iPageNow: 1}) => {
	const actId = _Vue.$actConfig && _Vue.$actConfig.actId ? _Vue.$actConfig.actId : '';
	return delay(500).then(() => {
		return new Promise((resolve, reject) => {
			window['amsCfg_' + flowId] = {
				'iAMSActivityId': actId,
				'iLotteryFlowId': flowId,
				'activityId': '284277',
				'pageSize': sData.iPageSize,
				'iPageNow': sData.iPageNow,
				'sData': {},
				'isForce': true,
				'getData': function (list, allData) {
					resolve({ list, allData });
				},
				'fFlowSubmitFailed': function (res) {
					reject(res);
				}
			}
			window['amsCfg_' + flowId].sData = {
				'sServiceType': window._Vue.$actConfig.gameCode,
				'pageSize': sData.iPageSize,
				'iPageNow': sData.iPageNow,
			}
			amsSubmit(actId, flowId);
		});
	})
}
// 获取提交地址或者填写地址
const doAddress = (flowId = '', sData = {}) => {
	sData['sTunnel'] = 1
	sData['sServiceType'] = window._Vue.$actConfig.gameCode
	const actId = _Vue.$actConfig && _Vue.$actConfig.actId ? _Vue.$actConfig.actId : '';
	return delay(500).then(() => {
		return new Promise((resolve, reject) => {
			window['amsCfg_' + flowId] = {
				'iActivityId': actId,
				'iFlowId': flowId,
				'_everyRead': true,
				'sData': sData,
				'gameId': window._Vue.$actConfig.gameCode,
				'success': (data) => {
					resolve(data)
				},
				'fail': (data) => {
					reject(data)
				}
			}
			amsSubmit(actId, flowId);
		})
	})
}

function getQueryString (name) {
	let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	let r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return decodeURIComponent(r[2]);
	};
}
function submit (flowId, sData) {
	sData['openidA'] = (typeof (window._Vue.$route) !== 'undefined' && typeof (window._Vue.$route.query) !== 'undefined' && typeof (window._Vue.$route.query.openidA) !== 'undefined') ? window._Vue.$route.query.openidA : ''
	sData['openidA'] = sData['openidA'] ? sData['openidA'] : getQueryString('openidA');
	sData['stime'] = getQueryString('time') || '';
	const bindInfo = {
		sArea: window.milo.cookie.get('acctype') === 'wx' ? 1 : 2,
		...window.bindInfo
	}
	sData['sArea'] = bindInfo.sArea
	if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
		sData['sPlatId'] = '0'
	} else {
		sData['sPlatId'] = '1'
	}
	sData['sPartition'] = bindInfo.sPartition
	sData['sRoleId'] = bindInfo.sRoleId
	sData['sTunnel'] = 1
	sData['sServiceType'] = window._Vue.$actConfig.gameCode
	const actId = _Vue.$actConfig && _Vue.$actConfig.actId ? _Vue.$actConfig.actId : '';
	return delay(500).then(() => {
		return new Promise((resolve, reject) => {
			/**
       * 用于缓存ams回调配置
       * 由于ams配置是全局的，并且类似单例模式，导致了同个flowid多次调用时，回调函数调用的都是首次配置的
       * 因此需要ReceivedCb局部变量来缓存cb，根据id执行回调
       */
			window[`getGiftMain_${flowId}`] && (delete window[`getGiftMain_${flowId}`]);
			window['amsCfg_' + flowId] = {
				iAMSActivityId: actId,
				'activityId': '227164',
				'gameId': window._Vue.$actConfig.gameCode,
				'sData': sData,
				'onGetGiftSuccessEvent': function (res) {
					const { sPackageName, iPackageId } = res
					if (res.iRet === 0) {
						resolve({ ...res, sPackageName, iPackageId });
					} else {
						reject(res);
					}
				},
				'onGetGiftFailureEvent': function (res) {
					reject(res);
				}
			}
			amsSubmit(actId, flowId);
		});
	})
}

const doReceiveAction = (flowId = '', sData = {}) => {
	if (typeof (window.bindInfo) === 'undefined' || !window.bindInfo || !window.bindInfo.sRoleId) {
		let res = {sMsg: ''}
		return new Promise((resolve, reject) => {
			miloLogin().then(LoginManager => {
				LoginManager.checkLogin((userInfo) => {
					const { $actConfig: {gameCode = ''} = {} } = window._Vue;
					if (gameCode === 'supercore') {
						resolve(submit(flowId, sData))
					} else {
						res.sMsg = '请先绑定角色'
						reject(res)
					}
				}, () => {
					res.sMsg = '请先登录活动页面再参与活动'
					reject(res)
				})
			})
		})
	};
	return submit(flowId, sData);
}
export const getBookQuota = (gid) => {
	return new Promise((resolve, reject) => {
		request.post('getBookQuotaAuth', {
			gids: [gid]
		}).then((res) => {
			let data = JSON.parse(res)
			if (data.ret === 0) {
				let status = 0
				if (data.books.length > 0) {
					if (data.books[0].gid && data.books[0].quota === 1) {
						status = 1
					}
				}
				resolve(status)
			} else {
				reject(data.msg)
			}
		})
	})
}
const doSubscribe = () => {
	return new Promise((resolve, reject) => {
		request.post('bookNewGame', {
			gid: 1262,
			business: 'app_h5_experiencecenter_game'
		}).then((data) => {
			data = JSON.parse(data)
			if (data.ret === 0) {
				if (window.Tgclub && window.Tgclub.changeBookGamePhoneNumDialog) {
					let mobile = data.mobile ? data.mobile : ''
					let countrycode = data.countrycode ? data.countrycode : ''
					console.log(mobile)
					window.Tgclub.changeBookGamePhoneNumDialog(JSON.stringify({
						gid: that.gid,
						mobile: mobile,
						countrycode: countrycode
					}))
				}
				resolve(1)
			} else {
				reject(data.msg)
				// alert(data.msg ? data.msg : '服务繁忙，请稍后再试')
			}
		})
	})
}
/**
 * @param {类型} type ams, link
 * @param {参数} argv 参数， 类型为ams时，为ams id, 为link时，url
 */
/* global amsSubmit */
export const doAction = (type, argv, sData) => {
	const actMode = (window._Vue || {}).$actMode || 'production';
	sData = {...window.bindInfo, ...sData, isBuilt: window.Ingame ? '1' : ''};
	if (actMode !== 'production') return Promise.resolve({});
	if (type === 'link') return (window.href = argv);
	else if (type === 'ams') return doAmsAction(argv, sData);
	else if (type === 'ame') return doAmeAction(argv, sData);
	else if (type === 'record') return doRecordAction(argv, sData);
	else if (type === 'received') return doReceiveAction(argv, sData);
	else if (type === 'subscribe') return doSubscribe();
	else if (type === 'address') return doAddress(argv, sData)
	return Promise.resolve({});
}
export const miloLogin = () => {
	const actMode = (window._Vue || {}).$actMode || 'production';
	if (actMode !== 'production') return Promise.resolve({ });
	return new Promise((resolve, reject) => {
		window.milo.ready(() => {
			window.need('biz.login', function (LoginManager) {
				resolve(LoginManager);
			})
		})
	})
}
/**
 * @param {类型} fixedOption 对象, 已经定义在main.js里
 * @param {参数} sData 对象， 需要提交的参数
 */
export const TAnalytics = (fixedOption, sData) => {
	let analyticsCreator = {
		serverUrl: 'https://web.xinyue.qq.com/xya',
		options: null,
		loadTime: null,
		hashFlagTime: null,
		init: () => {
			setTimeout(() => {
				analyticsCreator.initData();
				analyticsCreator.initOptions();
				analyticsCreator.initEvents();
				if (analyticsCreator.options.isspa) {
					analyticsCreator.initHashChangeEvent()
				}
				analyticsCreator.sendEnter();
				analyticsCreator.sendPageStayTime();
			}, 50)
		},
		initOptions: () => {
			analyticsCreator.options = {
				dataid: fixedOption.dataid,
				apiid: fixedOption.apiid,
				isspa: fixedOption.isspa || 1,
				activityid: fixedOption.activityid
			}
			if (!(analyticsCreator.options.dataid && analyticsCreator.options.isspa && analyticsCreator.options.apiid && analyticsCreator.options.activityid)) {
				if (console && console.error) {
					console.error('dataid and isspa and apiid and activityid is required prop in script\'s prop')
				}
			}
		},
		initData: () => {
			analyticsCreator.loadTime = (new Date()).getTime()
			analyticsCreator.hashFlagTime = this.loadTime
		},
		moloGetCookie: (sName, sDefaultValue) => {
			let sRE = '(?:; |^)' + sName + '=([^;]*);?'
			let oRE = new RegExp(sRE)
			if (oRE.test(document.cookie)) {
				return unescape(RegExp['$1'])
			} else {
				return sDefaultValue || null
			}
		},
		getBaseData: () => {
			let xyuin = ''
			let sessionId = ''
			let loginType = ''
			let isLogined = analyticsCreator.moloGetCookie('IED_LOG_INFO2') ? analyticsCreator.unSerialize(analyticsCreator.moloGetCookie('IED_LOG_INFO2')) : ''
			if (!isLogined || isLogined === '') {
				isLogined = analyticsCreator.moloGetCookie('IED_LOG_INFO2_QC') ? analyticsCreator.unSerialize(analyticsCreator.moloGetCookie('IED_LOG_INFO2_QC')) : ''
			}
			if (!isLogined || isLogined === '') {} else {
				if (isLogined.loginType === 'wx') {
					sessionId = analyticsCreator.utils.getCookie('access_token')
					xyuin = isLogined.openid
					loginType = 2
				} else if (isLogined.loginType === 'qc') {
					sessionId = analyticsCreator.utils.getCookie('access_token')
					xyuin = isLogined.openid
					loginType = 3
				} else {
					sessionId = analyticsCreator.utils.getCookie('skey')
					let uin = analyticsCreator.utils.getCookie('uin')
					xyuin = uin ? uin.replace(/^((o0)|(o))/, '') : ''
					loginType = 1
				}
				let userAgent = window.navigator.userAgent
				let sysid = 3
				if (/Android/i.test(navigator.userAgent)) {
					sysid = 1
				} else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
					sysid = 2
				}
				let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
				let nettype = (connection && connection.type) ? connection.type : ''
				switch (nettype) {
				case 'wifi':
					nettype = 1;
					break;
				case 'cellular':
					nettype = 6;
					break;
				case 'ethernet':
					nettype = 7;
					break;
				default:
					nettype = 8
				}
				let url = window.location.href
				let referrer = document.referrer
				let that = analyticsCreator;
				let tempRs = {
					xyuin: xyuin,
					sysid: sysid,
					logintype: loginType,
					useragent: userAgent,
					brand: brand,
					model: model,
					sessionid: sessionId,
					nettype: nettype,
					url: url,
					referrer: referrer,
					itemtype: fixedOption.itemtype || '1001',
					dataid: that.options.dataid,
					activityid: that.options.activityid
				}
				var rs = {}
				for (var key in tempRs) {
					if (tempRs[key] || tempRs[key] === 0) {
						rs[key] = tempRs[key]
					}
				}
				return rs
			}
		},
		getCommitCacheData: (params) => {
			let baseClonedData = analyticsCreator.getBaseData()
			if (!params) {
				return baseClonedData
			}
			let keys = ['eventtype', 'itemid', 'businessid', 'sgameid', 'giftid', 'moduleid', 'ext', 'gopenid', 'staytime', 'appid', 'channelid', 'customid', 'itemtype', 'logintype', 'sessionid']
			for (var i = 0; i < keys.length; i++) {
				var key = keys[i]
				// itemtype可以传空串 => ""
				if (key === 'itemtype' && !params[key] && typeof params[key] === 'string' && params[key].length === 0) {
					baseClonedData[key] = params[key]
				}
				// 其他情况不能为空
				if (params[key]) {
					baseClonedData[key] = params[key]
				}
				if (typeof fixedOption.pageid !== 'undefined' && fixedOption.pageid) {
					baseClonedData['pageid'] = fixedOption.pageid
				}
				return baseClonedData
			}
		},
		commit: (params) => {
			if (!params['eventtype']) {
				params['eventtype'] = '1002'
			}
			let commitData = analyticsCreator.getCommitCacheData(params);
			console.log(commitData)
			analyticsCreator.utils.sendData(commitData);
		},
		initEvents: () => {
			let that = analyticsCreator;
			if (!analyticsCreator.options.isspa) {
				window.onbeforeunload = () => { // 'pagestaytime', 'eventid', 'businessid', {pagestaytime:((new Date()).getTime() - that.loadTime)}
					let stayCommitData = that.getStayTimeParams(((new Date()).getTime() - that.loadTime))
					let storeData = that.getCommitCacheData(stayCommitData)
					that.utils.addItemsToVisitTimeList(storeData)
				}
			} else {
			// 由于vue-router较新版路由切换时无法触发浏览器的onhashchange事件，故采用模拟事件
				window.onmyhashchange = function (evt) { // 'pagestaytime', 'eventid', 'businessid', {pagestaytime:(curTime - that.hashFlagTime)}
					let curTime = (new Date()).getTime()
					let stayCommitData = that.getStayTimeParams(curTime - that.hashFlagTime)
					let storeData = that.getCommitCacheData(stayCommitData)
					// 需要取跳转前的url
					storeData.url = evt.oldURL
					that.utils.addItemsToVisitTimeList(storeData)
					that.hashFlagTime = curTime
					that.sendPageStayTime()
					that.sendEnter()
				}
				window.onbeforeunload = function () {
					let curTime = (new Date()).getTime()
					let stayCommitData = that.getStayTimeParams(curTime - that.hashFlagTime)
					let storeData = that.getCommitCacheData(stayCommitData)
					that.utils.addItemsToVisitTimeList(storeData)
				}
			}
		},
		initHashChangeEvent: () => {
			let location = window.location
			let oldURL = location.href
			let oldHash = location.hash
			// 每隔100ms检测一下location.hash是否发生变化
			setInterval(function () {
				let newURL = location.href
				let newHash = location.hash
				// 如果hash发生了变化,且绑定了处理函数...
				if (newHash !== oldHash && typeof window.onmyhashchange === 'function') {
					// execute the handler
					window.onmyhashchange({
						type: 'hashchange',
						oldURL: oldURL,
						newURL: newURL
					})
					oldURL = newURL
					oldHash = newHash
				}
			}, 100)
		},
		getStayTimeParams: (stayTime) => {
			let stayData = {
				staytime: stayTime
			}
			let pageParamSetting = null
			if (fixedOption && fixedOption.pageParamSetting) {
				pageParamSetting = fixedOption.pageParamSetting
			} else {
				pageParamSetting = {}
			}
			analyticsCreator.utils.mergeBToA(stayData, pageParamSetting);
			return stayData
		},
		sendEnter: () => {
			if (fixedOption && fixedOption.disableAutoSendEnter) {
				return
			}
			let that = analyticsCreator;
			setTimeout(function () {
				if (fixedOption && fixedOption.disableAutoSendEnter) {
					return
				}
				let preData = { eventtype: '1001' };
				let pageParamSetting = null;
				if (fixedOption && fixedOption.pageParamSetting) {
					pageParamSetting = fixedOption.pageParamSetting
				} else {
					pageParamSetting = {}
				}
				that.utils.mergeBToA(preData, pageParamSetting);
				that.utils.sendData(that.getCommitCacheData(preData))
			}, 200)
		},
		sendPageStayTime: () => {
			if (fixedOption && fixedOption.disableAutoSendStayTime) {
				return
			}
			let pageStayTimeList = analyticsCreator.utils.getVisitTimeListFromLocalStorage();
			if (pageStayTimeList.length) {
				for (let i = 0; i < pageStayTimeList.length; i++) {
					analyticsCreator.utils.sendData(pageStayTimeList[0])
				}
			}
			analyticsCreator.utils.clearPageVisitTimeList()
		},
		unSerialize: (jsonStr, de) => {
			de = de || 0;
			jsonStr = jsonStr.toString();
			if (!jsonStr) return {};
			let retObj = {}
			let obj1Ret = jsonStr.split('&')
			if (obj1Ret.length === 0) return retObj
			for (let i = 0; i < obj1Ret.length; i++) {
				if (!obj1Ret[i]) continue
				let ret2 = obj1Ret[i].split('=')
				if (ret2.length >= 2) {
					let ret0 = obj1Ret[i].substr(0, obj1Ret[i].indexOf('='))
					let ret1 = obj1Ret[i].substr(obj1Ret[i].indexOf('=') + 1);
					if (!ret1) ret1 = ''
					if (ret1.indexOf('#') > -1) {
						ret1 = ret1.split('#')[0]
					}
					if (ret0) retObj[ret0] = de === 0 ? decodeURIComponent(ret1) : ret1
				}
			}
			return retObj
		},
		utils: {
			trim: (str) => {
				return str ? str.replace(/^\s+|\s+$/gm, '') : str
			},
			getCookie: (key) => {
				let reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
				let arr = document.cookie.match(reg)
				if (arr) {
					return arr[2]
				} else {
					return null
				}
			},
			getJsonCookie: () => {
				let that = this
				let cookieStr = document.cookie;
				if (cookieStr) {
					return '{' + cookieStr.split(';').map((item) => {
						let idx = item.indexOf('=')
						let arr = item.split('=')
						let key = that.trim(arr[0]);
						let value = idx + 1 < item.length ? that.trim(item.substring(idx + 1)) : '';
						return '"' + key + '":"' + value + '"'
					}).join(',') + '}'
				} else {
					return '{}'
				}
			},
			mergeBToA: (a, b) => {
				if (b && a) {
					for (var key in b) {
						a[key] = b[key]
					}
				}
			},
			sendData: (params) => {
				params.time = (new Date()).getTime();
				var rqImg = new Image(1, 1);
				rqImg.src = analyticsCreator.serverUrl + '?params=' + encodeURIComponent(JSON.stringify(params)) + '&id=' + encodeURIComponent(analyticsCreator.options.apiid)
			},
			getVisitTimeListFromLocalStorage: function () {
				let list = localStorage.getItem('visit_time_list');
				if (list) {
					return JSON.parse(list)
				} else {
					return []
				}
			},
			addItemsToVisitTimeList: function (items) {
				if (fixedOption && fixedOption.disableAutoSendStayTime) {
					analyticsCreator.utils.clearPageVisitTimeList()
					return
				}
				if (!items) {
					return
				}
				var list = utils.getVisitTimeListFromLocalStorage();
				if (items instanceof Array) {
					list = list.concat(items)
				} else {
					list.push(items)
				}
				localStorage.setItem('visit_time_list', JSON.stringify(list))
			},
			clearPageVisitTimeList: () => {
				if (!analyticsCreator.utils.getVisitTimeListFromLocalStorage().length) {
					return
				}
				localStorage.setItem('visit_time_list', JSON.stringify([]))
			}
		}
	}
	analyticsCreator.init()
	setTimeout(function () {
		analyticsCreator.commit(sData)
	}, 60)
}



// WEBPACK FOOTER //
// ./src/components/actModules/src/utils.js